export const FETCH_PERSON_COURSES_END = "FETCH_PERSON_COURSES_END";
export const LOAD_PERSON_COURSE_TO_EDIT = "LOAD_PERSON_COURSE_TO_EDIT";
export const RESET_DEFAULT_NEW_PERSON_COURSE = "RESET_DEFAULT_NEW_PERSON_COURSE";
export const RESET_DEFAULT_PERSON_COURSE_TO_EDIT = "RESET_DEFAULT_PERSON_COURSE_TO_EDIT";
export const RESET_DEFAULT_COURSE_TO_EDIT = "RESET_DEFAULT_COURSE_TO_EDIT";
export const TOGGLE_EDIT_PERSON_COURSE_DIALOG = "TOGGLE_EDIT_PERSON_COURSE_DIALOG";
export const TOGGLE_NEW_PERSON_COURSE_DIALOG = "TOGGLE_NEW_PERSON_COURSE_DIALOG";
export const TOGGLE_PERSON_COURSE_EDIT_STATE = "TOGGLE_PERSON_COURSE_EDIT_STATE";
export const UPDATE_ADD_PERSON_COURSE_FIELD = "UPDATE_ADD_PERSON_COURSE_FIELD";
export const UPDATE_EDIT_PERSON_COURSE_FIELD = "UPDATE_EDIT_PERSON_COURSE_FIELD";
export const UPDATE_NEW_PERSON_COURSE = "UPDATE_NEW_PERSON_COURSE";
export const UPDATE_PERSON_COURSE_FIELD = "UPDATE_PERSON_COURSE_FIELD";
export const FILTER_COURSES = "FILTER_COURSES";
export const FILTER_PERSON_COURSE_LIST_BY_PERSON_ID = "FILTER_PERSON_COURSE_LIST_BY_PERSON_ID";
export const FILTER_PERSON_COURSE_LIST_BY_COURSE_TYPE = "FILTER_PERSON_COURSE_LIST_BY_COURSE_TYPE";
export const FILTER_PERSON_COURSE_LIST_BY_COURSE_STATUS = "FILTER_PERSON_COURSE_LIST_BY_COURSE_STATUS";

